import React, {useState} from 'react';
import {Button, SvgIcon, Tab, Tabs} from "@mui/material";
import localStrings from "../../../localStrings";
import {getUriSetting, saveUriSetting, SELECTED_TAB} from "../../../utils/optionsUriLocalStorage";
import useAuth from "../../../hooks/useAuth";
import PageWithTitle from "../../../components/pages/pageWithTitle";
import {Link as RouterLink, useParams} from "react-router-dom";
import {
    chartImplementationListRoute,
    dashboardBaseRoute,
    establishmentListRoute,
} from "../../../routes/dashboard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {MODE_EDIT} from "../../../components/CrudFrom/GeneralEditor";
import EstablishmentCreateUpdateForm from "../../Establishments/EstablishmentAddView/EstablishmentCreateUpdateForm";
import ChartImplementationCreateUpdateForm from "../ChartImplementationAddView/ChartImplementationCreateUpdateForm";
import Integration from "../../Establishments/EstablishmentDetailsView/Integration";
import RhMapping from "../../Establishments/EstablishmentDetailsView/rhMapping";
import ViewChartImplementation from "./ViewChartImplementation";
import MDDescription from "./MDDescription";

const ChartImplementationDetailsView = () => {
  const {currentBrand} = useAuth()
  const [currentTab, setCurrentTab] = useState(getUriSetting(SELECTED_TAB) || 'general');
    let {chartImplementationId} = useParams();


  const searchParams = new URLSearchParams(window.location.search);
  const urlBack = searchParams.get('urlBack');
  const urlBackTitle = searchParams.get('urlBackTitle');

  const handleTabsChange = (event, value) => {
    saveUriSetting(SELECTED_TAB, value)
    setCurrentTab(value);
  };

  function getMainButtons() {
    return (
      <>
        {urlBack && urlBackTitle &&
          <RouterLink to={decodeURI(urlBack)}
                      style={{ textDecoration: 'none' }}
          >
            <Button
              color="primary"
              variant="contained"
              startIcon={(
                <SvgIcon>
                  <ArrowBackIcon />
                </SvgIcon>
              )}
            >
              {urlBackTitle}
            </Button>
          </RouterLink>
        }
        <RouterLink to={'/' + dashboardBaseRoute + '/' + chartImplementationListRoute}
                    style={{ textDecoration: 'none' }}
        >
          <Button
            color="primary"
            variant="contained"
            startIcon={(
              <SvgIcon>
                <ArrowBackIcon />
              </SvgIcon>
            )}
          >
            {localStrings.backToList}
          </Button>
        </RouterLink>
      </>
    )
  }

  return (
    <PageWithTitle title={localStrings.chartImplementation} mainButtons={getMainButtons()}>


        <Tabs
            onChange={handleTabsChange}
            scrollButtons="auto"
            value={currentTab}
            textColor="secondary"
            variant="scrollable"
        >
            <Tab label={localStrings.general} value="general"/>
            <Tab label={localStrings.viewChartImplementation} value="view"/>
            <Tab label={localStrings.description} value="description"/>

        </Tabs>
        {currentTab === 'general' && <ChartImplementationCreateUpdateForm modeEdit={MODE_EDIT}/>}
        {currentTab === 'view' && <ViewChartImplementation chartImplementationId={chartImplementationId}/>}
        {currentTab === 'description' && <MDDescription chartImplementationId={chartImplementationId}/>}
    </PageWithTitle>
  );
};

export default ChartImplementationDetailsView;
